<!--suppress AngularNgOptimizedImage -->
<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- LADO IZQUIERDO / PERFIL -->
      <div class="col-lg-4 col-md-12">
        <div class="card card-personal-profile">
          <div class="profile-content">
            <img class="profile-img" [src]="resolvedPanelImage" alt="Foto del Usuario" />
            <div class="profile-text">
              <div class="profile-name">
                {{ param ? 'EDITAR' : 'NUEVO' }} USUARIO
              </div>
              <div class="profile-subtext">Complete la informacion requerida</div>
            </div>
          </div>
        </div>
      </div>

      <!-- LADO DERECHO / FORMULARIO -->
      <div class="col-lg-8 col-md-12">
        <div class="card">
          <form [formGroup]="userForm" class="register-form m-4" data-tour="user-form">
            <!-- DATOS DE ACCESO -->
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>lock</mat-icon>
                DATOS DE ACCESO
              </div>
              <div class="descripcion-seccion">CON ESTOS DATOS PODRAS ACCEDER A LA PLATAFORMA</div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>TIPO DE USUARIO</mat-label>
                    <mat-select formControlName="idTipoUsuario" required data-tour="user-tipo">
                      <mat-option *ngFor="let row of roleOptions" [value]="row.idTipoUsuario">
                        {{ row.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="userForm.get('idTipoUsuario')?.touched && userForm.get('idTipoUsuario')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">TIPO DE USUARIO ES OBLIGATORIO.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>USUARIO</mat-label>
                    <input formControlName="usr" matInput required data-tour="user-usr"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('usr')?.touched && userForm.get('usr')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL NOMBRE DE USUARIO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('usr')?.touched && userForm.get('usr')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS, NUMEROS, ESPACIOS, PUNTOS, GUIONES Y GUIONES BAJOS.</small>
                  </div>
                </div>

                <div class="col-md-8 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>CORREO ELECTRONICO</mat-label>
                    <input formControlName="email" matInput required data-tour="user-email"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('email')?.touched && userForm.get('email')!.hasError('email')" class="custom-error-below">
                    <small class="text-danger">DIRECCION DE CORREO INVALIDA.</small>
                  </div>
                  <div *ngIf="userForm.get('email')?.touched && userForm.get('email')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CORREO ELECTRONICO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('email')?.touched && userForm.get('email')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">INGRESE UNA DIRECCION DE CORREO VALIDA.</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- DATOS PERSONALES -->
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>person</mat-icon>
                DATOS PERSONALES
              </div>
              <div class="descripcion-seccion">INFORMACION GENERAL DEL USUARIO PARA IDENTIFICACION Y CONTACTO</div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE(S)</mat-label>
                    <input formControlName="nombres" matInput required data-tour="user-nombres"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('nombres')?.touched && userForm.get('nombres')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL NOMBRE ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('nombres')?.touched && userForm.get('nombres')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>PRIMER APELLIDO</mat-label>
                    <input formControlName="primerApellido" matInput required data-tour="user-apellido-paterno"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('primerApellido')?.touched && userForm.get('primerApellido')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL PRIMER APELLIDO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('primerApellido')?.touched && userForm.get('primerApellido')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SEGUNDO APELLIDO</mat-label>
                    <input formControlName="segundoApellido" matInput required data-tour="user-apellido-materno"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('segundoApellido')?.touched && userForm.get('segundoApellido')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL SEGUNDO APELLIDO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('segundoApellido')?.touched && userForm.get('segundoApellido')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field *ngIf="userForm.get('movil')" appearance="outline" class="example-full-width">
                    <mat-label>TELEFONO MOVIL</mat-label>
                    <ngx-mat-intl-tel-input
                      formControlName="movil"
                      [preferredCountries]="preferredCountries"
                      [enablePlaceholder]="true" data-tour="user-movil">
                    </ngx-mat-intl-tel-input>
                  </mat-form-field>
                  <div *ngIf="userForm.get('movil')?.touched && userForm.get('movil')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL NUMERO DE CELULAR ES OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>
                      {{ (userForm.get('settlementSearch')?.value ? 'COLONIA' : 'CODIGO POSTAL') | regionWord }}
                    </mat-label>

                    <input
                      matInput
                      [matAutocomplete]="auto"
                      formControlName="settlementSearch"
                      (blur)="onSettlementBlur()" data-tour="user-cp-colonia"/>

                    <mat-autocomplete #auto="matAutocomplete"
                                      (optionSelected)="setSelectedSettlement($event.option.value)"
                                      [displayWith]="displayFn">
                      <mat-option *ngFor="let option of settlements" [value]="option">
                        {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CODIGO POSTAL ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">INGRESA UN CODIGO POSTAL VALIDO.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>DIRECCION</mat-label>
                    <textarea formControlName="domicilio" matInput required data-tour="user-domicilio"></textarea>
                  </mat-form-field>
                  <div *ngIf="userForm.get('domicilio')?.touched && userForm.get('domicilio')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL DOMICILIO ES OBLIGATORIO.</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- UBICACION Y EMPRESA -->
            <!-- ✅ Responsable: ni siquiera mostramos la seccion -->
            <div class="seccion-formulario" *ngIf="!isResponsable">
              <div class="titulo-seccion">
                <mat-icon>business</mat-icon>
                UBICACION Y EMPRESA
              </div>
              <div class="descripcion-seccion">INFORMACION DE LA EMPRESA A LA QUE PERTENECE</div>

              <div class="row">
                <!-- ✅ Grupo SOLO cuando no es Supervisor (admin/otros lo eligen) -->
                <div class="col-md-6 mb-2" *ngIf="!isSupervisor">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>GRUPO EMPRESARIAL</mat-label>
                    <mat-select formControlName="idGEMP" (selectionChange)="getBranchesByGemp()" required data-tour="user-gemp">
                      <mat-option *ngFor="let row of businessGroups" [value]="row.idGEMP">{{ row.nombre }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- ✅ Sucursal: Admin y Supervisor la eligen -->
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SUCURSAL</mat-label>
                    <mat-select formControlName="idSucursal" required data-tour="user-sucursal">
                      <mat-option *ngFor="let row of branches" [value]="row.idSucursal">{{ row.nombre }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="archiveForm" class="register-form m-4">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>photo_camera</mat-icon>
                IMAGEN DE USUARIO
              </div>
              <div class="descripcion-seccion">SUBE UNA FOTO PARA IDENTIFICACION</div>

              <app-file-upload
                data-tour="user-imagen"
                formControlName="imagen"
                [acceptedTypes]="'image/*'"
                [externalSrc]="param ? userImagen : null"
                [circle]="true"
                [targetKB]="10"
                [initialMaxSize]="320">
              </app-file-upload>
            </div>

            <button
              data-tour="user-btn-guardar"
              (click)="confirmAdd()"
              [disabled]="(!userForm.valid) && !param"
              [ngClass]="{
                'button-custom': true,
                'disabled': (!userForm.valid) && !param
              }"
              color="primary"
              mat-button>
              {{
                (!userForm.valid) && !param
                  ? 'FORMULARIO INCOMPLETO'
                  : (param ? 'EDITAR USUARIO' : 'CREAR USUARIO')
              }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
